'use client'

import {
  useState,
} from 'react'

import {
  RotateCcw,
  Loader2,
} from 'lucide-react'

import {
  useSellerId,
} from '@/hooks/useSellerId'

import {
  useCurrentUser,
} from '@/hooks/useCurrentUser'

const DEMO_SELLER_ID =
  10086

const DEMO_CUSTOMER_IDS = [
  21150,
  10086,
]

export function DemoResetButton() {
  const {
    sellerId,
  } =
    useSellerId()

  const {
    userId,
  } =
    useCurrentUser()

  const [
    loading,
    setLoading,
  ] =
    useState(false)

  const isDemoResetAllowed =
    Number(
      sellerId || 0
    ) ===
      DEMO_SELLER_ID &&
    DEMO_CUSTOMER_IDS.includes(
      Number(
        userId || 0
      )
    )

  const isSellerDemoUser =
    Number(
      userId || 0
    ) === 10086

  if (
    !isDemoResetAllowed
  ) {
    return null
  }

  async function handleReset() {
    const confirmed =
      window.confirm(
        [
          '¿Resetear la experiencia demo?',
          '',
          'Esto reiniciará onboarding, perfil corto, progreso de cursos e insignias para este usuario demo.',
        ].join('\n')
      )

    if (!confirmed) {
      return
    }

    try {
      setLoading(
        true
      )

      const response =
        await fetch(
          '/api/demo/reset',
          {
            method: 'POST',
            credentials:
              'include',
          }
        )

      const json =
        await response
          .json()
          .catch(
            () => null
          )

      if (
        !response.ok ||
        !json?.ok
      ) {
        throw new Error(
          json?.error ||
          'No se pudo resetear la demo.'
        )
      }

      /*
       * Hard reload para que
       * onboarding, badges,
       * progreso, profile, etc.
       * vuelvan a consultarse.
       */
      window.location.href =
        '/moments'
    } catch (error) {
      console.error(
        '[DemoResetButton]',
        error
      )

      window.alert(
        'No se pudo resetear la demo.'
      )
    } finally {
      setLoading(
        false
      )
    }
  }

  return (
    <button
      type="button"
      disabled={
        loading
      }
      onClick={() =>
        void handleReset()
      }
      className={[
        'fixed bottom-5',
        isSellerDemoUser
          ? 'right-64'
          : 'right-5',
        'z-[9999]',
        'inline-flex items-center gap-2',
        'rounded-full',
        'border border-destructive/25',
        'bg-background/90',
        'px-4 py-2.5',
        'text-xs font-semibold',
        'text-destructive',
        'shadow-xl',
        'backdrop-blur-xl',
        'transition',
        'hover:bg-destructive/5',
        'disabled:cursor-not-allowed',
        'disabled:opacity-60',
      ].join(' ')}
      title="Resetear experiencia demo"
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <RotateCcw className="h-4 w-4" />
      )}

      {loading
        ? 'Reseteando...'
        : 'RESET DEMO'}
    </button>
  )
}